<template>
  <div class="crManage cr-bg-white-1">
    <!-- 全局loading组件 -->
    <cr-loading :loading="loading"></cr-loading>
    <!-- 短信推送 -->
    <div class="msg cr-in-block cr-flex cr-ai-center">
      <!-- <span class="cr-fs-md cr-text-black-1">短信推送</span> -->
      <!-- <a-switch v-model="sendMsg" @change="updateMsg" /> -->
      <span @click="showSwitchBox"><a>动态推送</a></span>
      <MessageSwitchBox :switchVisible="switchVisible" @closeSwitchBox="closeSwitchBox" />
    </div>
    <!-- tabs状态筛选 -->
    <a-tabs v-model="queryParams.state" @change="tabChange">
      <a-tab-pane v-for="tab in tabs" :key="tab.value" :tab="tab.name"></a-tab-pane>
    </a-tabs>
    <!-- 筛选 -->
    <div class="filterBox cr-pr-2">
      <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" class="cr-flex cr-ai-center cr-jc-start cr-pl-2">
        <span class="cr-nowrap cr-fs-md cr-text-black-1">版权类型</span>
        <a-select v-model="queryParams.coprType" placeholder="请选择" class="cr-flex-1" @change="search">
          <a-select-option v-for="item in corpDict" :key="item.code" :value="item.code">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" class="cr-flex cr-ai-center cr-jc-start cr-pl-2">
        <span class="cr-nowrap cr-fs-md cr-text-black-1">案件编号</span>
        <a-input v-model="queryParams.caseNo" placeholder="请输入案件编号" class="cr-flex-1" @keyup.enter.native="search"></a-input>
      </a-col>
      <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" class="cr-flex cr-ai-center cr-jc-start cr-pl-2">
        <span class="cr-nowrap cr-fs-md cr-text-black-1">软件名称</span>
        <a-input v-model="queryParams.softwareName" placeholder="请输入软件名称" class="cr-flex-1" @keyup.enter.native="search"></a-input>
      </a-col>
      <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" class="cr-flex cr-ai-center cr-jc-start cr-pl-2">
        <span class="cr-nowrap cr-fs-md cr-text-black-1">著作权人</span>
        <a-input v-model="queryParams.copyrightOwner" placeholder="请输入著作权人" class="cr-flex-1" @keyup.enter.native="search"></a-input>
      </a-col>
      <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" class="cr-flex cr-ai-center cr-jc-start cr-pl-2">
        <span class="cr-nowrap cr-fs-md cr-text-black-1">联系人</span>
        <a-input v-model="queryParams.contactor" placeholder="请输入联系人" class="cr-flex-1" @keyup.enter.native="search"></a-input>
      </a-col>
      <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" class="cr-flex cr-ai-center cr-jc-start cr-pl-2">
        <span class="cr-nowrap cr-fs-md cr-text-black-1">案件状态</span>
        <a-select v-model="queryParams.childState" class="cr-flex-1" placeholder="请选择" @change="search">
          <a-select-option v-for="item in childState" :key="item.code" :value="item.code">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" class="cr-flex cr-ai-center cr-jc-start cr-pl-2">
        <span class="cr-nowrap cr-fs-md cr-text-black-1">创建时间</span>
        <a-range-picker class="cr-flex-1" @change="timeChange1" />
      </a-col>
      <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" class="cr-flex cr-ai-center cr-jc-start cr-pl-2">
        <span class="cr-nowrap cr-fs-md cr-text-black-1">支付时间</span>
        <a-range-picker class="cr-flex-1" @change="timeChange2" />
      </a-col>
      <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" class="cr-flex cr-ai-center cr-jc-start cr-pl-2">
        <span class="cr-nowrap cr-fs-md cr-text-black-1">更新时间</span>
        <a-range-picker class="cr-flex-1" @change="timeChange3" />
      </a-col>
      <a-col :span="6" class="cr-flex cr-ai-center cr-jc-start cr-pl-2 search">
        <a-button class="btn" @click="reset">重置</a-button>
        <a-button class="btn" type="primary" @click="search">搜索</a-button>
      </a-col>
    </div>
    <!-- 背景色 -->
    <div class="greyLine"></div>
    <!-- 列表数据 -->
    <div class="tableBox cr-p-2">
      <div class="thead cr-flex cr-ai-center cr-px-2">
        <span class="cr-fw-5 cr-fs-md cr-text-black-1 cr-flex-4">案件信息</span>
        <span class="cr-fw-5 cr-fs-md cr-text-black-1 cr-flex-3">材料信息</span>
        <span class="cr-fw-5 cr-fs-md cr-text-black-1 cr-flex-1 cr-text-ct">付款信息</span>
        <span class="cr-fw-5 cr-fs-md cr-text-black-1 cr-w180 cr-text-ct">操作</span>
      </div>
      <div class="tbody">
        <template v-if="tableData.length > 0">
          <div class="tr cr-mt-1" v-for="item in tableData" :key="item.id">
            <!-- 案件编号等头部信息 -->
            <div class="top w-100 cr-px-2 cr-flex cr-ai-center cr-jc-between">
              <div class="cr-flex-2 cr-fs-md cr-text-grey-1 cr-flex cr-ai-center" :title="item.caseNo + ' (' + item.createdAt + ')'">
                <span>案件编号：</span>
                <cr-tooltip placement="topLeft">
                  <span class="cr-block cr-pr-2 cr-fs-ellipsis cr-cursor" v-copy="item.caseNo" @click="copySuccess">{{ item.caseNo + ' (' + item.createdAt + ')' }}</span>
                </cr-tooltip>
              </div>
              <div class="cr-flex-2 cr-fs-md cr-text-grey-1">
                联系人：
                <cr-tooltip placement="topLeft">
                  <span class="cr-cursor" v-copy="item.contactPerson" @click="copySuccess">{{ item.contactPerson || '' }}</span>
                </cr-tooltip>
                -
                <template v-if="item.seeMobileFlag">
                  <a-tooltip placement="topLeft" title="点击复制">
                    <span class="cr-cursor" v-copy="item.contactPhone" @click="seeMobile(item, false)">{{ item.contactPhone || '' }}</span>
                  </a-tooltip>
                </template>
                <template v-if="!item.seeMobileFlag && item.contactPhone">
                  <span class="cr-cursor" @click="seeMobile(item, true)">{{ item.contactPhone.substr(0, 3) + '******' + item.contactPhone.substr(9, 2) }}</span>
                </template>
              </div>
              <div class="cr-w180 cr-flex cr-jc-end">
                <span class="cr-fs-md cr-text-grey-1 cr-mr-1">案件状态:</span>
                <a-tooltip placement="topLeft" :title="'审核未通过:' + item.auditFailReason + ' ' + item.auditFailTime" v-if="item.childState == 31">
                  <span class="cr-fs-md cr-text-orange cr-cursor">{{ changeChildState(item.childState) }}</span>
                </a-tooltip>
                <span v-else class="cr-fs-md cr-text-orange">{{ changeChildState(item.childState) }}</span>
              </div>
            </div>
            <!-- 主体td内容 -->
            <div class="main cr-px-2 w-100 cr-flex">
              <!-- 案件信息 -->
              <div class="td cr-flex-4">
                <cr-tooltip placement="topLeft">
                  <h1 class="cr-fs-lg cr-text-black-1 cr-fw-5 cr-mt-2 cr-pr-2 cr-cursor" v-copy="item.fullName" @click="copySuccess">{{ item.fullName || '--' }}</h1>
                </cr-tooltip>
                <div class="cr-fs-md cr-text-grey-1 cr-pr-2 type">{{ item.registerTypeText + ' (' + item.processCycleText + ')' }}</div>
                <div class="cr-mans cr-flex cr-mt-1 cr-pr-2">
                  <div class="title cr-text-grey-1">著作权人:</div>
                  <cr-tooltip placement="topLeft">
                    <div class="cr-man cr-cursor cr-text-grey-2" v-copy="item.authorName" @click="copySuccess" :title="item.authorName">{{ item.authorName || '--' }}</div>
                  </cr-tooltip>
                </div>
              </div>
              <!-- 材料信息 -->
              <div class="td cr-flex-3">
                <template v-if="item.attachments">
                  <div :class="{ more: item.attachments.length > 5 }" class="cr-pt-2" :ref="item.caseNo">
                    <div class="info" v-for="(attachment, index) in item.attachments" :key="'attachment' + index">
                      <span class="cr-fs-md cr-text-grey-1 cr-mr-1">{{ attachment.createdAt }}</span>
                      <a class="cr-mr-1" @click.stop="showAttachment(attachment, item.caseNo)">{{ attachment.attachmentName }}</a>
                      <svg-icon icon-class="down" class="cr-cursor" @click="attachmentDown(attachment.attachmentUrl)"></svg-icon>
                    </div>
                  </div>
                  <div class="showMore cr-fs-md" @click="showMore(item.caseNo)" v-if="item.attachments.length > 5">
                    <span>点击更多</span>
                    <svg-icon icon-class="more" class="cr-cursor"></svg-icon>
                  </div>
                </template>
                <span class="cr-block cr-mt-3" v-if="!item.attachments || item.attachments.length == 0">--</span>
              </div>
              <!-- 付款信息 -->
              <div class="td cr-flex-1 cr-text-ct">
                <div v-if="item.couponAmount > 0" class="money cr-fs-md cr-fw-5 cr-mt-2">订单金额¥ {{ setAmount(item.originalPrice) }}</div>
                <div v-if="item.couponAmount > 0" class="discount cr-fs-md cr-fw-5">
                  优惠金额 <span>¥ {{ setAmount(item.couponAmount) }}</span>
                </div>
                <div class="total_money cr-fs-md cr-fw-5" :class="{ 'cr-mt-2': item.couponAmount == 0 }">合计 ¥ {{ setAmount(item.amount) }}</div>
                <div class="cr-fs-md cr-text-grey-1" v-if="item.transStateText != '待付款'">{{ item.payTime }}</div>
                <div class="moneyState" :class="{ warn: item.transStateText == '待付款' }">{{ item.transStateText }}</div>
              </div>
              <!-- 操作 -->
              <div class="td cr-w180">
                <div class="actionBox cr-pt-3">
                  <a v-if="item.childState == 10" class="action cr-fs-md" @click.stop="Pay(item)">支付</a>
                  <a v-if="item.childState == 10" class="action cr-fs-md" @click.stop="goDetail(item)">填写材料</a>
                  <a v-if="item.childState == 10 || item.childState == 20" class="action cr-fs-md" @click.stop="shareCase(item)">分享填写</a>
                  <a v-if="item.childState == 10" class="action cr-fs-md" @click.stop="confirmCancelCase(item)">取消案件</a>
                  <a v-if="item.childState == 20" class="action cr-fs-md" @click.stop="goDetail(item)">填写案件</a>
                  <a v-if="item.childState == 20 || item.childState == 30 || item.childState == 31 || item.childState == 32 || item.childState == 33 || item.childState == 34 || item.childState == 35 || item.childState == 40 || item.childState == 41 || item.childState == 42 || item.childState == 43 || item.childState == -40 || item.childState == -30" class="action cr-fs-md" @click.stop="goDetail(item)">查看详情</a>
                  <a v-if="item.amount != 0 && (item.childState == 20 || item.childState == 31 || item.childState == 33)" class="action cr-fs-md" @click.stop="refund(item)">申请退款</a>
                  <a v-if="item.childState == 30 || item.childState == 32 || item.childState == 34 || item.childState == 35 || item.childState == 40 || item.childState == 41 || item.childState == 42 || item.childState == 43 || item.childState == -40 || item.childState == -30" @click.stop="shareCase(item)" class="action cr-fs-md">分享案件</a>
                  <a v-if="item.childState == 31 || item.childState == 33" class="action cr-fs-md" @click.stop="goDetail(item)">修改案件</a>
                  <a v-if="item.childState == 31 || item.childState == 33" class="action cr-fs-md" @click.stop="shareCase(item)">分享修改</a>
                  <a v-if="item.childState == 32" class="action cr-fs-md" @click.stop="getCheckList(item)">确认核对表</a>
                  <a v-if="item.childState == 35" class="action cr-fs-md" @click.stop="downFile(item)">下载邮寄说明</a>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 暂无数据 -->
        <cr-nodata v-else></cr-nodata>
      </div>
    </div>
    <!-- 分页 -->
    <div class="pageBox cr-text-rt cr-pr-2 cr-pb-3 cr-flex cr-ai-center cr-jc-end" v-show="tableData.length > 0">
      <span class="cr-in-block cr-fs-md cr-text-black-1 cr-mr-1">共{{ total }}条 </span>
      <div class="cr-in-block">
        <a-pagination size="small" class="page" :pageSizeOptions="['10', '20', '30', '50', '100']" :pageSize.sync="queryParams.pageSize" show-quick-jumper show-size-changer v-model="queryParams.pageNum" :total="total" @change="pageChange" @showSizeChange="sizeChange" />
      </div>
    </div>
    <!-- 确认核对表 -->
    <check-list v-if="detailCaseNo" @refresh="search" :checkVisible.sync="checkVisible" :caseNo="detailCaseNo" />
    <!-- 查看材料 （图片预览） -->
    <div v-show="imgurl" class="showimg">
      <div class="zhezhao" />
      <img :src="imgurl" class="pic" alt="" />
      <div class="close" @click="closeimg">X</div>
    </div>
    <!-- 退款弹窗 -->
    <case-refund :visible.sync="refundFlag" :case="currentCase" @refresh="search"></case-refund>
    <!-- 分享案件弹窗 -->
    <a-modal v-model="shareModal" width="460px" title="链接已复制" :footer="null">
      <div class="share-modal-content">
        <p class="case-no">案件号：{{ shareCaseNo }}</p>
        <p class="case-desc">链接已复制，您可以直接分享给客户。</p>
        <div class="case-url">
          <div class="url cr-fs-ellipsis">{{ shareUrl }}</div>
          <a-button type="primary" v-copy="shareUrl" @click="copyOk" class="btn">复制链接</a-button>
        </div>
        <div class="footer">
          <a-button type="primary" ghost @click="shareModal = false">好的，知道了</a-button>
        </div>
      </div>
    </a-modal>
    <!-- 取消案件弹窗 -->
    <a-modal v-model="cancelCaseModal" @ok="cancelCase" @cancel="cancelCaseModal = false" width="440px" class="cancelCase">
      <p class="cr-mt-2">是否确认取消案件?</p>
    </a-modal>
  </div>
</template>

<script>
import checkList from './component/checklist.vue'
import CaseRefund from './component/caseRefund'
import MessageSwitchBox from './component/messageSwitchBox.vue'
import { childStateDict, list, corpDict, showCheckForm, cancelCopr } from '@/api/caseManage'
import { selectSmsSwitch, updateSmsSwitch, sendPay, downloadMaterials, saveRecord } from '@/api/common'
export default {
  data() {
    return {
      tabs: [
        {
          name: '全部案件',
          value: null
        },
        {
          name: '待付款',
          value: 1
        },
        {
          name: '办理中',
          value: 3
        },
        {
          name: '已完成',
          value: 4
        }
      ],
      currentCancelCase: {}, //当前取消案件的对应数据
      cancelCaseModal: false, //取消案件弹窗
      shareCaseNo: '', //当前分享案件的案件号
      shareModal: false, //分享案件弹窗
      shareUrl: '', //分享案件的url
      currentCase: {}, //申请退款弹窗对应的那条数据
      refundFlag: false,
      imgurl: undefined, //查看材料的  图片预览地址
      loading: false,
      sendMsg: false, //短信推送  false关闭
      queryParams: {
        beginTime: '', //开始时间
        caseNo: '', //	案件编号
        childState: undefined, //	案件子状态
        contactor: '', //联系人姓名或电话
        coprType: undefined, //版权类型
        copyrightOwner: '', //著作人
        createdEndTime: '', //创建时间止
        createdStartTime: '', //创建时间起
        endTime: '', //结束时间
        materialEndTime: '', //材料更新时间止
        materialStartTime: '', //材料更新时间起
        pageNum: 1, //当前页数,示例值(1)
        pageSize: 20, //显示条数,示例值(10)
        payEndTime: '', //支付时间止
        payStartTime: '', //支付时间起
        softwareName: '', //软件名称
        state: null //案件状态(见枚举)
      },
      total: 0, //数据总数
      tableData: [], //列表数据
      childState: [], //案件子状态
      corpDict: [], //版权类型
      checkVisible: false, // 确认核对表
      ownerVisible: false, // 著作权人信息
      detailCaseNo: '',
      switchVisible: false
    }
  },
  components: {
    checkList,
    CaseRefund,
    MessageSwitchBox
  },
  created() {
    if (this.$route.query.state == 1) {
      this.queryParams.state = Number(this.$route.query.state)
    }
    this.getMsgState()
    this.getChildStateDict()
    this.getCorpDict()
    this.getList()
  },
  methods: {
    showSwitchBox() {
      this.switchVisible = true
    },
    closeSwitchBox() {
      this.switchVisible = false
    },
    //查看手机号
    async seeMobile(item, flag) {
      item.seeMobileFlag = flag
      if (flag) {
        const res = await saveRecord({
          mobile: item.contactPhone
        })
      } else {
        this.copySuccess()
      }
    },
    //弹窗复制成功
    copyOk() {
      this.copySuccess()
      this.shareModal = false
    },
    //案件状态切换
    async tabChange(key) {
      this.queryParams.state = key
      this.tableData = []
      this.childState = []
      await this.getChildStateDict()
      this.search()
    },
    //下载邮寄材料
    async downFile(item) {
      const res = await downloadMaterials({
        caseNo: item.caseNo,
        fullName: item.fullName
      })
      window.open(res.data.ossUrl)
    },
    //根据案件子状态 判断跳  可编辑详情  还是  不可编辑详情
    getDetailUrl(item) {
      //待付款 待补充信息 平台审核未通过 确认表有误 跳可编辑
      if (item.childState == 10 || item.childState == 20 || item.childState == 31 || item.childState == 33) {
        return process.env.VUE_APP_BASE_URL + '/detailShare?caseNo=' + item.caseNo
      } else {
        return process.env.VUE_APP_BASE_URL + '/cannotShare?caseNo=' + item.caseNo
      }
    },
    //取消案件二次确认弹窗
    confirmCancelCase(item) {
      this.cancelCaseModal = true
      this.currentCancelCase = { ...item }
    },
    //取消案件
    async cancelCase() {
      const res = await cancelCopr({
        coprNub: this.currentCancelCase.caseNo
      })
      if (res.code == 0) {
        this.cancelCaseModal = false
        this.$message.success('取消成功!')
        this.search()
      }
    },
    //填写材料 填写案件 查看详情 修改案件
    goDetail(item) {
      //待付款 待补充信息 平台审核未通过 确认表有误 跳可编辑
      if (item.childState == 10 || item.childState == 20 || item.childState == 31 || item.childState == 33) {
        this.$router.push({
          path: '/businessCenter/caseDetail',
          query: {
            caseNo: item.caseNo
          }
        })
      } else {
        this.$router.push({
          path: '/businessCenter/cannotEdit',
          query: {
            caseNo: item.caseNo
          }
        })
      }
    },
    //分享案件 分享填写  分享修改
    shareCase(item) {
      this.shareUrl = this.getDetailUrl(item)
      this.shareCaseNo = item.caseNo
      this.shareModal = true
    },
    //申请退款
    refund(item) {
      this.currentCase = { ...item }
      this.refundFlag = true
    },
    //发起支付
    async Pay(item) {
      let href = window.location.href
      let url = href.split('?')['0']
      const res = await sendPay({
        syncCallBackRedirectUrl: url,
        amount: item.amount,
        outAccountId: this.$store.getters.userInfo.orgList[0].accountId,
        operatorId: this.$store.getters.userInfo.userId,
        orderNo: item.caseNo,
        tranContent: '版权工作台案件支付',
        // 优惠券新增字段如下
        costPrice: item.costPrice,
        couponAmount: item.couponAmount >= item.originalPrice ? item.originalPrice : item.couponAmount,
        originalPrice: item.originalPrice,
        couponIds: item.couponId ? [item.couponId] : []
      })
      if (res.code == 0) {
        window.open(res.data.url, '_self')
      }
    },
    //查看材料  图片预览
    showAttachment(attachment) {
      this.$router.push({
        path: '/businessCenter/checkMaterial',
        query: {
          item: JSON.stringify(attachment)
        }
      })
    },
    //关闭图片预览
    closeimg() {
      this.imgurl = undefined
    },
    //查询短信开关状态
    async getMsgState() {
      const res = await selectSmsSwitch()
      this.sendMsg = res.data
    },
    //修改短信开关状态
    async updateMsg() {
      const res = await updateSmsSwitch({ smsSwitch: this.sendMsg ? 1 : 0 })
      if (res.code == 0) {
        this.sendMsg = res.data
        let msg = res.data ? '开启' : '关闭'
        this.$message.success(msg + '成功!')
      }
    },
    //分页  pagesize
    sizeChange(current, size) {
      this.queryParams.pageNum = current
      this.queryParams.pageSize = size
      this.getList()
    },
    //分页 页数变化
    pageChange(current) {
      this.queryParams.pageNum = current
      this.getList()
    },
    //材料信息点击查看更多
    showMore(ref) {
      let selDom = this.$refs[ref][0]
      selDom.classList.remove('more')
      selDom.parentNode.removeChild(selDom.parentNode.childNodes[1])
    },
    // 确认核对表
    async getCheckList(item) {
      this.checkVisible = true
      this.detailCaseNo = item.caseNo
    },
    //复制成功的提示信息
    copySuccess() {
      this.$message.success('复制成功！')
    },
    //处理金额
    setAmount(val) {
      return Number(val) / 100
      // return (Number(val) / 100).toFixed(2)
    },
    //下载材料附件
    attachmentDown(url) {
      // window.open(url)
      let a = document.createElement('a')
      a.href = url
      a.download = true
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    //将案件子状态的值转为对应中文信息
    changeChildState(val) {
      // console.log('table', this.tableData)
      // console.log('val', val)
      // console.log('xyw1', this.childState)
      // console.log('xyw2', this.childState.find((n) => n.code == val))
      return this.childState.find((n) => n.code == val).label
    },
    //获取版权类型
    async getCorpDict() {
      const res = await corpDict()
      this.corpDict = res.data || []
    },
    //获取案件子状态
    async getChildStateDict() {
      const res = await childStateDict({
        caseState: this.queryParams.state
      })
      this.childState = res.data || []
    },
    //搜索  重置分页  获取列表数据
    search() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    //重置筛选  获取列表数据
    reset() {
      const state = this.queryParams.state
      this.queryParams = {
        beginTime: '',
        caseNo: '',
        childState: undefined,
        contactor: '',
        coprType: undefined,
        copyrightOwner: '',
        createdEndTime: '',
        createdStartTime: '',
        endTime: '',
        materialEndTime: '',
        materialStartTime: '',
        pageNum: 1,
        pageSize: 20,
        payEndTime: '',
        payStartTime: '',
        softwareName: '',
        state: null
      }
      this.queryParams.state = state
      this.search()
    },
    //获取列表数据
    async getList() {
      this.loading = true
      const res = await list(this.queryParams)
      this.tableData = (res.data && res.data.list) || []
      this.tableData.map((n) => {
        this.$set(n, 'seeMobileFlag', false)
      })
      this.total = (res.data && res.data.total) || 0
      this.loading = false
    },
    //创建时间筛选
    timeChange1(date, dateString) {
      // console.log(date, dateString)
      this.queryParams.createdStartTime = dateString[0]
      this.queryParams.createdEndTime = dateString[1]
      this.search()
    },
    //支付时间筛选
    timeChange2(date, dateString) {
      this.queryParams.payStartTime = dateString[0]
      this.queryParams.payEndTime = dateString[1]
      this.search()
    },
    //更新时间筛选
    timeChange3(date, dateString) {
      this.queryParams.materialStartTime = dateString[0]
      this.queryParams.materialEndTime = dateString[1]
      this.search()
    }
  }
}
</script>

<style lang="less" scoped>
.crManage {
  position: relative;
  min-height: calc(100vh - 74px);
  .msg {
    position: absolute;
    top: 22.5px;
    right: 24px;
    transform: translate(0, -50%);
    z-index: 33;
    .cr-fs-md {
      margin-right: 14px;
    }
  }
  .filterBox {
    margin-top: 15px;
    margin-bottom: 4px;
    overflow: hidden;
    .cr-flex {
      margin-bottom: 16px;
      .btn {
        margin-right: 15px;
      }
    }
    .cr-nowrap {
      margin-right: 12px;
      min-width: 56px;
    }
  }
  .greyLine {
    height: 10px;
    background: #f0f2f5;
  }
  .tableBox {
    .thead {
      height: 40px;
      background-color: #f5f5f5;
    }
    .tbody {
      .tr {
        border-radius: 1px;
        border: 1px solid #f0f0f0;
        .top {
          background-color: #fafafa;
          height: 40px;
          .cr-flex-1 {
            overflow: hidden;
          }
        }
        .main {
          padding-bottom: 20px !important;
          .more {
            max-height: 124px;
            overflow: hidden;
          }
          .showMore {
            margin: 16px 0;
            span {
              margin-right: 4px;
              color: #1664ff;
              cursor: pointer;
            }
            .cr-cursor {
              width: 12px;
              height: 10px;
            }
          }
          .type {
            margin-top: 24px;
          }
          .cr-mans {
            margin-bottom: 15px;
            line-height: 20px;
            .title {
              min-width: 70px;
            }
            .cr-man {
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
          .info {
            margin-bottom: 15px;
          }
          .money {
            color: #999999;
            height: 14px;
            text-decoration: line-through;
          }
          .discount {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #484848;
            line-height: 14px;
            margin-top: 12px;
            span {
              color: #ff6600;
            }
          }
          .total_money {
            height: 14px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #484848;
            margin-top: 12px;
            line-height: 14px;
          }
          .moneyState {
            margin: 10px auto 0 auto;
            width: 56px;
            height: 22px;
            line-height: 22px;
            text-align: center;
            color: #47ba97;
            background: rgba(71, 186, 151, 0.1);
            border-radius: 2px;
            &.warn {
              color: #ff5500;
              background: rgba(255, 85, 0, 0.1);
            }
          }
          // .actionBox {
          //   display: grid;
          //   grid-template-columns: 1fr 1fr;
          //   .action {
          //     position: relative;
          //     margin-bottom: 16px;
          //     color: rgba(22, 100, 255, 1);
          //     cursor: pointer;
          //     &:hover {
          //       color: rgba(22, 100, 255, 0.7);
          //     }
          //     &:nth-child(2n + 1) {
          //       // &::after {
          //       //   content: '';
          //       //   width: 1px;
          //       //   height: 13px;
          //       //   background: #f0f0f0;
          //       //   position: absolute;
          //       //   right: 0;
          //       // }
          //       justify-content: flex-end;
          //       // padding-right: 20px;
          //     }
          //     &:nth-child(2n) {
          //       justify-content: flex-end;
          //     }
          //   }
          // }
          .actionBox {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-end;
            .action {
              position: relative;
              margin-bottom: 16px;
              color: rgba(22, 100, 255, 1);
              cursor: pointer;
              white-space: nowrap;
              &:hover {
                color: rgba(22, 100, 255, 0.7);
              }
              &:nth-child(2n + 1) {
                &::after {
                  content: '';
                  width: 1px;
                  height: 13px;
                  background: #f0f0f0;
                  // font-size: 13px;
                  // color: #f0f0f0;
                  position: absolute;
                  right: -22px;
                }
                margin-right: 44px;
              }
              &:last-child {
                &::after {
                  content: '';
                  width: 1px;
                  height: 13px;
                  background: transparent;
                  position: absolute;
                  right: -22px;
                }
                margin-right: 0px;
              }
            }
          }
        }
      }
    }
  }
  .pageBox {
    .page {
      vertical-align: middle;
    }
  }
  .showimg {
    .zhezhao {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: #000;
      opacity: 0.7;
      z-index: 99;
    }
    .pic {
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 100;
      max-width: 1000px;
    }
    .close {
      position: fixed;
      top: 80px;
      right: 80px;
      width: 60px;
      height: 60px;
      background-color: #eee;
      border-radius: 50%;
      color: #666;
      font-size: 40px;
      text-align: center;
      line-height: 60px;
      z-index: 100;
      cursor: pointer;
      opacity: 0.7;
    }
  }
}
/deep/ .ant-modal-footer {
  border: none;
  margin-top: 20px;
  padding-bottom: 20px;
}
.share-modal-content {
  .case-no {
    height: 14px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
  }
  .case-desc {
    height: 14px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    margin-top: 14px;
  }
  .case-url {
    display: flex;
    align-items: center;
    margin-top: 20px;
    .url {
      width: 304px;
      height: 40px;
      background: @item-selected;
      border-radius: 2px;
      line-height: 40px;
      padding: 0 10px;
      margin-right: 10px;
    }
    .btn {
      height: 40px;
      flex: 1;
    }
  }
  .footer {
    margin-top: 20px;
    text-align: right;
  }
}
// /deep/.ant-modal-content {
//   height: 182px;
// }
</style>
